import _ from "lodash";
import Vue from "vue/dist/vue.esm";
import axios from "axios";
import VeeValidate from "vee-validate";
import dayjs, { locale } from "dayjs";
import "dayjs/locale/zh-tw";
import "dayjs/locale/zh-cn";
import "dayjs/locale/ja";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

dayjs.locale(window.locale || 'en');
dayjs.extend(customParseFormat);

axios.defaults.headers.common["X-CSRF-Token"] = document.querySelector("meta[name=csrf-token]").content;
axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";

Vue.use(VeeValidate);

Vue.component('coollightbox', CoolLightBox);
Vue.use(CoolLightBox);

Vue.filter("formatWeek", function (value) {
  if (value) {
    return dayjs().startOf('week').add(value, 'day').format('dddd');
  }
  return "";
});

window.app = new Vue({
  el: "#clientApplication",
  components: { CoolLightBox },
  data: {
    store: store,
    preference: preference,
    businessHours: business_hours,
    thumbnailDir: storage_url + 'stores/',
    environments: environments,
    showEnvIndex: null,
    menus: menus,
    showMenuIndex: null,
    images: menus.concat(environments),
    mobile: null,
    i18n: I18n,
    languages: languages,
    orderSetting: orderSetting,
    activedPage: 'storeInfo',
    current_locale: locale,
    canOrder: true
  },
  created: function () { },
  mounted: function () {
    $(".photo-slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 0,
      variableWidth: true
    });
    this.canOrder = isQueueing && !suspended && this.orderSetting.queueing_enabled || !isQueueing && this.orderSetting.reservation_enabled;
    if (!this.canOrder) {
      $('#shopDisableModal').modal('show');
    };
    $(function () {
      var header_height = $('.main-header').height();
      var body_height = $(window).height() - header_height;
      $('.main-body').css('min-height', body_height);
    });
    let dayjsLan = 'en';
    if (window.locale === 'zh-TW') {
      dayjsLan = 'zh-tw';
    } else if (window.locale=== 'zh-CN') {
      dayjsLan = 'zh-cn';
    } else if (window.locale === 'ja') {
      dayjsLan = 'ja';
    }
    dayjs.locale(dayjsLan);
  },

  methods: {
    showLightbox: function (image) {
      var url_split = image.file.url.split('/');
      // console.log('url_split', url_split)
      var route = url_split[url_split.length - 3] + '/' + url_split[url_split.length - 2] + '/' + url_split[url_split.length - 1];
      console.log('route', route)
      this.$refs.lightbox.show(route);
      // this.$refs.lightbox.show(image.file.url);
    },
    queryMobile: function () {
      var self = this;
      axios({
        url: `/stores/${this.store.permalink}/mobiles`,
        dataType: "json",
        method: "POST",
        data: { mobile: this.mobile }
      }).then(function (response) {
        window.location = response.data.url;
      });
    },
    photoSliderNext: function (event) {
      let x = event.target.dataset.id;
      $(x).slick("slickNext");
    },
    changeI18n: function () {
      I18n.locale = $('#language').val();
    }
  },
  computed: {
    environmentImage: function () {
      return this.environments ? this.environments.map((environment) => environment.file.url) : [];
    },
    menuImage: function () {
      return this.menus ? this.menus.map((menu) => menu.file.url) : [];
    }
  },
  watch: {
    current_locale: function (newLocale, oldLocale) {
      var url = new URL(window.location.href);
      url.searchParams.set('language', newLocale);

      window.location.href = url;
    }
  }
});
